import React, { useState, useEffect } from 'react';
import './index.less';
import ReactDOM from 'react-dom';
import Render from '@/components/Render';
import { isPreviewMode } from '@/utils/tool';
import { dispatch, getState } from '@/store';

const BubbleTip = props => {
  const {
    _attrs = {},
    tabIndex
  } = props;
  const {
    delay,
    content = '',
    enable,
    autoHidden
  } = _attrs;
  const [time, setTime] = useState(delay);
  const [tabs, setTabs] = useState({});
  const dd = content.replace(/<[^>]+>/g, ''); // 截取html标签

  const dds = dd.replace(/&nbsp;/ig, ''); // 截取空格等特殊标签

  const currentTabShow = (tabs[tabIndex] || 0) < 2;
  const isShow = enable && dds.replace(/\s*/g, '').length > 0 && currentTabShow;
  useEffect(() => {
    if (isPreviewMode()) {
      return;
    }

    const account = tabs[tabIndex] || 0;
    tabs[tabIndex] = account + 1;
    setTabs(tabs);

    if (isShow) {
      setTime(delay);
    }
  }, [tabIndex]);
  useEffect(() => {
    // if (isPreviewMode()) {
    //     return
    // }
    if (autoHidden && isShow && !isPreviewMode()) {
      const timer = setInterval(() => {
        setTime(n => {
          if (n <= 1) {
            clearInterval(timer);
          }

          return n - 1;
        });
      }, 1000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [tabIndex]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShow && /*#__PURE__*/React.createElement("div", {
    className: "c-popupBubble-component"
  }, time !== 0 && /*#__PURE__*/React.createElement("div", {
    className: "c-popupBubble-component-content"
  }, /*#__PURE__*/React.createElement("span", {
    className: "content",
    dangerouslySetInnerHTML: {
      __html: content
    }
  }), autoHidden && /*#__PURE__*/React.createElement("span", {
    className: "time"
  }, "(", time, "s)"))));
};

export default BubbleTip;